module.exports = __webpack_public_path__ + "media/img/specialize/item11-4c7b316a066c827ae3441b38eee3cde1.svg";